import React from 'react';
import { LockIcon, ZapIcon, ShieldCheckIcon, CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { heroImage } from '../data/product';

/** PENDING: replace with the live checkout URL once the sales platform is defined. */
const CHECKOUT_URL = 'https://session-ready-slp-72-ready-to-use-therapy-sessions-for-school-a.impultienda.ar/checkout';
const included = ['6 volumes · 72 stacked sessions', '5 instant-use bonuses', '300 landscape pages, screen or print', '432 ready targets at 3 levels', '48 take-home worksheets', 'Lifetime access to your files'];
export function Pricing() {
  return <section id="pricing" aria-labelledby="pricing-heading" className="w-full bg-blush text-ink" data-id="element-198" data-mp="25tsp8vd6iaxq">
      <div className="max-w-2xl mx-auto px-5 py-16 sm:py-20" data-id="element-199" data-mp="20vhgknyme6h3">
        <div className="text-center" data-id="element-200" data-mp="3h638ob618upi">
          <p className="text-[11px] font-semibold uppercase tracking-[1.8px] text-gold-deep" data-id="element-201" data-mp="3h97ns3l1dauy">
            Complete package
          </p>
          <h2 id="pricing-heading" className="mt-3 font-display text-plum text-3xl sm:text-5xl" data-id="element-202" data-mp="3w08e485c1mad">
            Everything you need to run the{' '}
            <span className="text-coral-deep" data-id="element-203" data-mp="9si9e0cgel27">next 36 weeks</span>
          </h2>
        </div>

        <div className="mt-8 overflow-hidden rounded-3xl border border-blush-dark bg-white shadow-card" data-id="element-204" data-mp="erbpm0j4kq62">
          <div className="bg-plum px-5 py-5 text-center" data-id="element-205" data-mp="3d97hhqroq2tz">
            <h3 className="font-display text-xl text-white sm:text-2xl" data-id="element-206" data-mp="3dasavd29jfq9">
              Session Ready SLP — Complete Package
            </h3>
            <p className="mt-1 text-[13px] font-semibold text-gold-hover" data-id="element-207" data-mp="3n7es7rvdronj">
              6 Volumes + 5 Bonuses
            </p>
          </div>

          <div className="p-5 sm:p-7" data-id="element-208" data-mp="3rzeq7erw47hh">
            <img src={heroImage.src} alt={heroImage.alt} width={heroImage.width} height={heroImage.height} loading="lazy" className="mx-auto aspect-[1024/688] w-full max-w-2xl rounded-2xl object-cover" data-id="element-209" data-mp="2uihe80y7ce0l" />

            <ul className="mt-6 grid gap-2.5 sm:grid-cols-2" data-id="element-210" data-mp="2mhrt9p627i3n">
              {included.map(item => <li key={item} className="flex items-start gap-2 text-sm" data-id="element-211" data-mp="316el2qcvi2br">
                  <span className="mt-0.5 flex h-[18px] w-[18px] flex-none items-center justify-center rounded-full bg-gold/20" data-id="element-212" data-mp="318r313imscot">
                    <CheckIcon className="h-3 w-3 text-gold-deep" aria-hidden="true" data-id="element-213" data-mp="28hqxgo4nj0v1" />
                  </span>
                  {item}
                </li>)}
            </ul>

            <div className="mt-7 border-t border-cream-dark pt-6 text-center" data-id="element-214" data-mp="2ihhp8i1tv1rf">
              {/* PENDING (Lucas): confirm the anchor value before launch. */}
              <p className="text-[13px] text-ink-soft" data-id="element-215" data-mp="3tuk7dhjkrzdp">
                Total value{' '}
                <span className="text-ink-muted line-through" data-id="element-216" data-mp="3ows4jshe6suq">$90 USD</span>
              </p>
              <div className="mt-1 flex items-start justify-center gap-1 text-plum" data-id="element-217" data-mp="aneup3bsktz">
                <span className="mt-2.5 font-display text-3xl" data-id="element-218" data-mp="59grygepa9tm">$</span>
                <span className="font-display text-6xl leading-[0.9] sm:text-7xl" data-id="element-219" data-mp="5arvcf48hfk7">
                  27
                </span>
                <span className="mt-3 text-[13px] font-semibold text-ink-muted" data-id="element-220" data-mp="3rgos94arjqis">
                  USD
                </span>
              </div>

              <div className="mt-3 flex flex-wrap justify-center gap-2" data-id="element-221" data-mp="j26ecly55gr9">
                <span className="rounded-full border border-gold bg-gold px-3 py-1 text-[10px] font-semibold uppercase tracking-widest text-gold-ink" data-id="element-222" data-mp="o0hm8r4vlh6u">
                  Save $63
                </span>
                <span className="rounded-full border border-cream-dark px-3 py-1 text-[10px] font-semibold uppercase tracking-widest text-ink-soft" data-id="element-223" data-mp="e9n33vmxexpm">
                  One-time payment
                </span>
                <span className="rounded-full border border-cream-dark px-3 py-1 text-[10px] font-semibold uppercase tracking-widest text-ink-soft" data-id="element-224" data-mp="16qpjwtpt3ffn">
                  No subscription
                </span>
              </div>

              <CtaButton href={CHECKOUT_URL} className="mt-5" data-id="element-225" data-mp="3a6ukkwn7m5ho">
                Get instant access — $27
              </CtaButton>

              <p className="mt-3 text-xs text-ink-muted" data-id="element-226" data-mp="35b5q37q1res8">
                Backed by the 7-day money-back guarantee
              </p>

              <ul className="mt-4 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-medium text-ink-soft" data-id="element-227" data-mp="1svozw45gm4p">
                <li className="flex items-center gap-1.5" data-id="element-228" data-mp="3szyjawfab8j5">
                  <LockIcon className="h-4 w-4 text-gold-deep" aria-hidden="true" data-id="element-229" data-mp="3o7ylpamosrpq" />
                  Secure checkout
                </li>
                <li className="flex items-center gap-1.5" data-id="element-230" data-mp="kj3ng0wwmoek">
                  <ZapIcon className="h-4 w-4 text-gold-deep" aria-hidden="true" data-id="element-231" data-mp="kkol3zeimngn" />
                  Access in 5 minutes
                </li>
                <li className="flex items-center gap-1.5" data-id="element-232" data-mp="1ygpx06lh2azi">
                  <ShieldCheckIcon className="h-4 w-4 text-gold-deep" aria-hidden="true" data-id="element-233" data-mp="23dq32hibndqm" />
                  7-day guarantee
                </li>
              </ul>
            </div>
          </div>
        </div>

        <p className="mt-4 text-center text-xs text-ink-muted" data-id="element-234" data-mp="2ccjvdvomdhyd">
          Price in USD. You&apos;ll be charged the equivalent in your local
          currency.
        </p>
      </div>
    </section>;
}